import { fetchAuthSession } from 'aws-amplify/auth';

export const downloadFinalReport = async (decedentId) => {
  const token = (await fetchAuthSession()).tokens?.accessToken?.toString();
  const response = await fetch(
    `${process.env.REACT_APP_API_BASE_URL}/question/final-report?decedentId=${decedentId}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      redirect: 'follow',
    }
  );

  if (response.status !== 200) {
    throw new Error('Fetch error');
  }

  return response.blob();
};

export const downloadEstateDispositionSummary = async (decedentId) => {
  const token = (await fetchAuthSession()).tokens?.accessToken?.toString();
  const response = await fetch(
    `${process.env.REACT_APP_API_BASE_URL}/question/estate-disposition-summary?decedentId=${decedentId}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      redirect: 'follow',
    }
  );

  if (response.status !== 200) {
    throw new Error('Fetch error');
  }

  return response.blob();
};
